import { atom } from "jotai";

export enum TypeformUtmSource {
  desktop = "desktop",
  mobile = "mdot",
}

export interface HomeTypeform {
  isOpenTypeform: boolean;
  typeformCampaignId: number;
  typeformUtmSource: TypeformUtmSource;
}

export const homeTypeformAtom = atom<HomeTypeform>({
  isOpenTypeform: false,
  typeformCampaignId: 1,
  typeformUtmSource: TypeformUtmSource.desktop,
});
